export function pluralCount(n: number, unit: string): string {
  return `${n.toLocaleString("ko-KR")}${unit}`;
}
export function truncate(s: string, max: number): string {
  return s.length <= max ? s : `${s.slice(0, Math.max(0, max - 1))}…`;
}
/** 출처 칩에 쓸 도메인 표시. */
export function hostLabel(url: string): string {
  try { return new URL(url).hostname.replace(/^www\./, ""); }
  catch { return url.slice(0, 24); }
}
